<template>
  <div class="mt-4">
    <!-- Tab bar -->
    <div class="border-b border-gray-200 bg-white rounded-t-lg">
      <nav class="flex -mb-px px-4">
        <button
          v-for="tab in tabs" :key="tab.id"
          class="px-4 py-2.5 text-sm font-medium border-b-2 transition-colors"
          :class="activeTab === tab.id
            ? 'border-blue-500 text-blue-600'
            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
          @click="activeTab = tab.id"
        >{{ tab.label }}</button>
      </nav>
    </div>

    <!-- Tab content -->
    <Attribution_Health
      v-if="activeTab === 'attribution'"
      :entity-id="entityId"
    />
    <CostAttributionFlow
      v-if="activeTab === 'cost_flow'"
      :entity-id="entityId"
      :metric-id="metricId"
      :year="year"
      :metric-links="metricLinks"
      :page-type="pageType"
    />
  </div>
</template>

<script>
import Attribution_Health from '@/components/Entity/Attribution_Health.vue';
import CostAttributionFlow from '@/components/InsightsNew/CostAttributionFlow.vue';

export default {
  name: 'PanelManagementTabs',
  components: { Attribution_Health, CostAttributionFlow },
  props: {
    entityId: { type: Number, default: null },
    metricId: { type: Number, default: null },
    year: { type: Number, default: null },
    metricLinks: { type: Array, default: null },
    pageType: { type: String, default: null },
  },
  data() {
    return {
      activeTab: 'attribution',
      tabs: [
        { id: 'attribution', label: 'Attribution Health' },
        { id: 'cost_flow', label: 'Cost Attribution' },
      ],
    };
  },
};
</script>
